import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Row, Button } from 'reactstrap';
import RoundError from 'react-md-icon/dist/RoundError';
import { connect } from 'react-redux';

import { CloseButton, SubmitButton, Checkbox } from '../..';
import { HELLO_SIGN_ID, SIMPLE_SIGN_ID } from '../../../constants/productTiers';
import { updateEsignatureProductTier, LOADING_PROP_TYPE, UPDATE_ESIGNATURE_PRODUCT_TIER } from '../../../modules';
import { displayGremlinsToaster } from '../../../helpers';

import './ChangeEsignatureTier.scss';

class ChangeEsignatureTier extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isBillingAccepted: false,
      enableValidationMessage: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      loading,
      onClose,
      isHelloSignEnabled,
      intl: {
        formatMessage,
      },
    } = this.props;
    if (prevProps.loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'loading' && loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'complete') {
      onClose();
      // trigger toaster in AHR
      let message = '';
      if (isHelloSignEnabled) {
        message = formatMessage({ id: 'ESIGNATURE_ENABLED_SUCCESS' });
      } else {
        message = formatMessage({ id: 'ESIGNATURE_DISABLED_SUCCESS' });
      }
      displayGremlinsToaster(message, 'success', 3000);
    }
  }

  onSubmit(isEnable) {
    const { isBillingAccepted } = this.state;
    const { intl: { formatMessage }, onClose } = this.props;
    if (isEnable) {
      if (isBillingAccepted) {
        this.props.updateEsignatureProductTier(HELLO_SIGN_ID, formatMessage, onClose);
      } else {
        this.setState({ enableValidationMessage: true });
      }
    } else {
      this.props.updateEsignatureProductTier(SIMPLE_SIGN_ID, formatMessage, onClose);
    }
  }

  render() {
    const {
      isHelloSignEnabled,
      isLegacy,
      onClose,
      esignaturePricingData,
      loading,
    } = this.props;
    const { enableValidationMessage } = this.state;
    return (
      <Fragment>
        {isHelloSignEnabled ?
          // disable dialog
          <div className="px-4 py-4 rounded">
            {/* we use a negative margin on the header so that the bottom border extends all the way to the edge of the container */}
            <div className="modal-header pt-0 pb-4 mx-n4 px-4">
              <div className="h4 mb-0 font-weight-bold">
                <FormattedMessage id="DISABLE_ENHANCED_ESIGNATURE" />
              </div>
              <CloseButton onClick={onClose} />
            </div>
            <div className="pt-4"><strong><FormattedMessage id="DISABLE_ESIGNATURE_PREFACE" /></strong></div>
            <div className="pt-4"><p><FormattedMessage id="DISABLE_ESIGNATURE_LIST_HEADER" /></p></div>
            <ul className="pl-4">
              <div><li><FormattedMessage id="SEND_TO_EMPLOYEES" /></li></div>
              <div className={`${isLegacy ? 'd-none' : ''}`}><li><FormattedMessage id="INCLUDE_IN_ONBOARDING" /></li></div>
              <div className={`${isLegacy ? 'd-none' : ''}`}><li><FormattedMessage id="CONFIGURE_NEW_DOCUMENTS" /></li></div>
            </ul>
            <div>
              {isLegacy ?
                <p><FormattedMessage id="LEGACY_DISABLE_MESSAGE" /></p>
              :
                <div>
                  <p><FormattedMessage id="NON_LEGACY_DISABLE_MESSAGE" /></p>
                  <p><FormattedMessage id="CAN_COMPLETE_SIGNATURE_REQUESTS" /></p>
                </div>
              }
            </div>
            <Row className="pr-3 pt-3 flex-row-reverse">
              <SubmitButton
                color="primary"
                onSubmit={() => this.onSubmit(false)}
                defaultLabel="DISABLE"
                submittingLabel="DISABLING"
                disabled={loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'loading'}
                submitting={loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'loading'}
              />
              <Button color="default" className="mr-3" onClick={() => onClose()}><FormattedMessage id="CANCEL" /></Button>
            </Row>
          </div>
        :
          // enable dialog
          <div className="px-4 py-4 rounded">
            {/* we use a negative margin on the header so that the bottom border extends all the way to the edge of the container */}
            <div className="modal-header pt-0 pb-4 mx-n4 px-4">
              <div className="h4 mb-0 font-weight-bold">
                <FormattedMessage id="ENABLE_ENHANCED_ESIGNATURE" />
              </div>
              <CloseButton onClick={onClose} />
            </div>
            <h5 className="pt-4 font-weight-bold">
              ${esignaturePricingData.monthlyCost} <FormattedMessage id="PER_MONTH_BASIS" />
              &nbsp;+ ${esignaturePricingData.costPerRequest} <FormattedMessage id="PER_SIGNATURE_REQUEST" />
            </h5>
            <div className="pt-3"><strong><FormattedMessage id="ENABLE_ESIGNATURE_LIST_HEADER" /></strong></div>
            <ul className="pl-4">
              <div><li className="pt-2"><FormattedMessage id="EVERY_SENT_DOCUMENT" /></li></div>
              <div className={`${!isLegacy ? 'd-none' : ''}`}><li><FormattedMessage id="EVERY_DOC_IN_ONBOARDING" /></li></div>
            </ul>
            <div className="pt-3"><strong><FormattedMessage id="YOU_CAN" />:</strong></div>
            <ul className="pl-4">
              <div><li className="pt-2"><FormattedMessage id="CONTINUE_STANDARD_AT_NO_COST" /></li></div>
              <div className={`${isLegacy ? 'd-none' : ''}`}><li><FormattedMessage id="CONTINUE_ENHANCED_AT_NO_COST" /></li></div>
              <div><li className=""><FormattedMessage id="DISABLE_AT_ANY_TIME" /></li></div>
            </ul>
            <Checkbox
              id="billingConfirmation"
              name="billingConfirmation"
              labelDisplay={this.props.intl.formatMessage({ id: 'ESIGNATURE_BILLING_CONFIRMATION' })}
              labelPosition="right"
              onChange={(e) => {
                this.setState({ isBillingAccepted: e.target.checked });
                this.setState({ enableValidationMessage: false });
              }}
            />
            <div className={`${enableValidationMessage ? '' : 'd-none'}`}>
              <span className="esignature-warning"><RoundError viewBox="0 0 24 28" style={{ fontSize: '1.5rem', lineHeight: 1 }} /></span>
              <span className="esignature-warning pl-2"><FormattedMessage id="PLEASE_CHECK_BOX" /></span>
            </div>
            <Row className="pr-3 pt-3 flex-row-reverse">
              <SubmitButton
                color="primary"
                onSubmit={() => this.onSubmit(true)}
                defaultLabel="ENABLE"
                submittingLabel="ENABLING"
                disabled={loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'loading'}
                submitting={loading[UPDATE_ESIGNATURE_PRODUCT_TIER] === 'loading'}
              />
              <Button color="default" className="mr-3" onClick={() => onClose()}><FormattedMessage id="CANCEL" /></Button>
            </Row>
          </div>
        }
      </Fragment>
    );
  }
}

ChangeEsignatureTier.propTypes = {
  isHelloSignEnabled: PropTypes.bool.isRequired,
  isLegacy: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  esignaturePricingData: PropTypes.shape({
    monthlyCost: PropTypes.string,
    costPerRequest: PropTypes.string,
  }).isRequired,
  updateEsignatureProductTier: PropTypes.func.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default connect(
  (state) => {
    const { appState: { loading } } = state;
    return {
      loading,
    };
  },
  dispatch => ({
    updateEsignatureProductTier: (productTierId, formatMessage, onClose) =>
      dispatch(updateEsignatureProductTier(productTierId, formatMessage, onClose)),
  })
)(injectIntl(ChangeEsignatureTier));




// WEBPACK FOOTER //
// ./src/components/Forms/ChangeEsignatureTier/ChangeEsignatureTier.jsx